// --------- App Specific Constants --------- //

const user_roles = { super_admin: 1, admin: 2, staff: 3, customer: 4 };

const orderStatuses = {
	created: 1,
	placed: 2,
	accepted: 3,
	pending: 4,
	processed: 5,
	completed: 6,
	rejected: 7,
	cancelled: 8,
	backordered: 9,
	yorkton: 10,
};

// Display labels for order statuses (frontend only - doesn't affect backend)
const orderStatusLabels = {
	created: "created",
	placed: "placed",
	accepted: "accepted",
	pending: "partially delivered",
	processed: "ready",
	completed: "delivered",
	rejected: "rejected",
	cancelled: "cancelled",
	backordered: "backordered",
	yorkton: "yorkton",
};

// Statuses to hide from frontend dropdowns
const hiddenOrderStatuses = ["created", "rejected"];

const cartItemStatuses = {
	active: 1,
	backordered: 2,
};

const APP_CONSTANTS = { user_roles, orderStatuses, cartItemStatuses, orderStatusLabels, hiddenOrderStatuses };

export default APP_CONSTANTS;
